import { graphql } from "relay-runtime"

export const chMedicationFragment = graphql`
  fragment chMedicationFragment on ch_Medication {
    __typename
    id
    name
    patientId
    pharmaCode
    startDate
    endDate
    unit
    morningDosage
    noonDosage
    eveningDosage
    nightDosage
    usageInstructions
    internalNotes
    templateId
    templateCategory
    type
    productUrl
    packageSize
    updatedAt
    updatedBy
    createdAt
    createdBy
    refuseSubstitutes
    numberOfPackages
    isPermanentPrescription
  }
`

export const chMedicationFragmentInline = graphql`
  fragment chMedicationFragmentInline on ch_Medication @inline {
    __typename
    id
    name
    patientId
    pharmaCode
    startDate
    endDate
    unit
    morningDosage
    noonDosage
    eveningDosage
    nightDosage
    usageInstructions
    internalNotes
    templateId
    templateCategory
    type
    productUrl
    packageSize
    updatedAt
    updatedBy
    createdAt
    createdBy
    refuseSubstitutes
    numberOfPackages
    isPermanentPrescription
  }
`
